module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/poster.c494aa05.jpg";